<template lang="html">
  <div class="ctn-cookies row" v-if="display">
		<div class="text column">
			En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de cookies pour vous proposer une navigation adaptée à votre utilisation. <br/>
		</div>
		<div class="btn btn-gold" @click="setCookie">
			Fermer
		</div>
  </div>
</template>

<script>
export default {
	data () {
		return {
			display: true
		}
	},
	mounted () {
		if (this.$cookie.get('cookie-validate')) {
			this.display = (this.$cookie.get('cookie-validate') === 'false')
		} else {
			this.$cookie.set('cookie-validate', false)
		}
	},
	methods: {
		setCookie () {
			this.display = false
			this.$cookie.set('cookie-validate', true)
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/common/components/cookie.vue